<template>
	<div>
		<h1>
			Create a category
		</h1>

		<form class="mt-4" @submit.prevent="createCategory">
			<div class="form-group">
				<label for="name">
					<small class="text-muted">CATEGORY NAME</small>
				</label>
				<input type="text" class="form-control" name="name" placeholder="Name" v-model="name" required autofocus :disabled="loading">
			</div>

        	<div class="form-group">
				<label for="content">
					<small class="text-muted">CATEGORY IMAGE</small>
				</label>
				<file-input @change="setIcon" required placeholder="Choose an image (replace old if set)" :disabled="loading" />
			</div>
			<!-- <div class="form-group">
				<label for="name">
					<small class="text-muted">CATEGORY DESCRIPTION</small>
				</label>
				<textarea class="form-control" name="description" placeholder="Description" v-model="description" required autofocus :disabled="loading" />
			</div> -->

			<!-- <div class="form-group">
				<label for="parent">
					<small class="text-muted">PARENT ROOT</small>
				</label>
				<select class="form-control" name="parent" v-model="parent_id" :disabled="loading">
					<option v-for="category in categories" :key="category.id" :value="category.id">
						{{ category.name }}
					</option>
				</select>
			</div> -->

			<!-- <div class="form-check mb-2">
				<input class="form-check-input" type="checkbox" id="is_featured" v-model="is_featured" :disabled="loading">
				<label class="form-check-label" for="is_featured">
					Is it a Dimashqi category?
				</label>
			</div> -->

			<!-- <div class="form-check mb-2">
				<input class="form-check-input" type="checkbox" id="has_dimensions" v-model="has_dimensions" :disabled="loading">
				<label class="form-check-label" for="has_dimensions">
					Products have dimensions?
				</label>
			</div> -->

			<!-- <div class="form-check mb-2">
				<input class="form-check-input" type="checkbox" id="can_upload_attachments" v-model="can_upload_attachments" :disabled="loading">
				<label class="form-check-label" for="can_upload_attachments">
					Product orders have the ability of attaching logos?
				</label>
			</div> -->

			<!-- <div class="form-group">
				<label>
					<small class="text-muted">CATEGORY ATTRIBUTES</small>
				</label>
				<multiselect v-model="attributes"
					:close-on-select="false"
					:options="attributes"
					placeholder="Search or add attribute"
					tag-placeholder="Add a new ttribute"
					multiple
					taggable
					@tag="addAttribute" />
			</div> -->

			<button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{running: loading}">
				{{ loading ? 'Creating…' : 'Create' }}
				<div class="ld ld-ring ld-spin" />
			</button>
		</form>

		<div class="alert alert-danger mt-4" v-if="!loading && error">
			<p class="mb-0 text-center">
				{{ error }}
			</p>
		</div>
	</div>
</template>

<script>
	import {getError} from '../../../helpers';
	import FileInput from '../../FileInput';
	import Multiselect from 'vue-multiselect';
	import store from '../../../store';
	import { mapState } from 'vuex';

	export default {
		components: {
			FileInput,
			'multiselect': Multiselect
		},

		data() {
			return {
				name: '',
				description: '',
				tag: '',
				is_featured: false,
				has_dimensions: false,
				can_upload_attachments: false,
				parent_id: null,
				attributes: [],
				image: null,
				
				loading: false,
				error: '',
			};
		},
		
		methods: {
			createCategory() {
				this.loading = true;

				this.$store.dispatch('categories/create', {
					name: this.name,
					description: this.description,
					tag: this.tag,
					is_featured: this.is_featured,
					has_dimensions: this.has_dimensions,
					can_upload_attachments: this.can_upload_attachments,
					attributes: this.attributes,
					parent_id: this.parent_id,
					image: this.image,
				}).then(() => {
					this.$router.push({name: 'categories'});
				}).catch(e => {
					this.error = getError(e);
					this.loading = false;
				});
			},

			addAttribute(attribute) {
				this.attributes.push(attribute);
			},

			setIcon(files) {
				this.image = files[0];
			},
		},

		computed: {
			...mapState({
				categories: state => state.categories.categories,
			})
		},

		async beforeRouteEnter(to, from, next) {
			await store.dispatch('categories/fetchAll');
			next(vm => {
				if (to.query.parent)
					vm.parent_id = to.query.parent;
			});
		},

		meta: {
			title: 'Create a category',

			meta: [
				{property: 'og:title', content: 'Create a category / Al-Shayah'},
			],
		},
	};
</script>
